import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CallManIcon from '../../../../../common/icons/mojorange/call_man_circle.svg';
import CallCenterIcon from '../../../../../common/icons/call-center_circle_2.svg';
import MaxIcon from '../../../../../common/icons/max.svg';
import './style.scss';

class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { username, theme, chat } = this.props;

        const icon =
            chat.submode === 'MAX' ? (
                <MaxIcon />
            ) : theme.includes('mojorange2') ? (
                <CallManIcon />
            ) : (
                <CallCenterIcon />
            );

        return (
            <div className="opl-widget-chat--header">
                <div className="opl-widget-chat--header-icon">{icon}</div>
                <div className="opl-widget-chat--header-names">
                    <p className="opl-widget-chat--header-names_username">{username}</p>
                    <p className="opl-widget-chat--header-names_title">
                        {username === 'Max'
                            ? 'Twój wirtualny asystent Orange'
                            : 'Konsultant Orange'}
                    </p>
                </div>
            </div>
        );
    }
}

Header.defaultProps = {
    available: false,
    username: ''
};

Header.propTypes = {
    available: PropTypes.bool.isRequired,
    username: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        theme:
            state.settings.widget && state.settings.widget.theme
                ? state.settings.widget.theme.split(' ')
                : ['default'],
        chat: state.chat
    };
};

export default connect(mapStateToProps)(Header);
